import { render, staticRenderFns } from "./TabletContentSection.vue?vue&type=template&id=1b20f87e"
import script from "./TabletContentSection.vue?vue&type=script&lang=js"
export * from "./TabletContentSection.vue?vue&type=script&lang=js"
import style0 from "./TabletContentSection.vue?vue&type=style&index=0&id=1b20f87e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports